import FilterConstants from '../../filter-constants';

export function getResponseType(sliderValue: string): string | null {
  const responseTypeSlider = Number(sliderValue);
  let result = null;
  if (responseTypeSlider < FilterConstants.slider.chebyshevLimit) {
    result = FilterConstants.responseType.chebyshev;
  } else if (
    responseTypeSlider >= FilterConstants.slider.chebyshevLimit &&
    responseTypeSlider <= FilterConstants.slider.butterworthLimit
  ) {
    result = FilterConstants.responseType.butterworth;
  } else if (
    responseTypeSlider > FilterConstants.slider.butterworthLimit &&
    responseTypeSlider < FilterConstants.slider.besselButterworthLimit
  ) {
    result = FilterConstants.responseType.butterworthBessel;
  } else if (responseTypeSlider >= FilterConstants.slider.besselButterworthLimit) {
    result = FilterConstants.responseType.bessel;
  }
  return result;
}

export function getResponseValue(sliderValue: string, passbandAttenuation: string): number {
  const responseTypeSlider = Number(sliderValue);
  const responseType = getResponseType(sliderValue);
  let result = null;
  if (responseType === FilterConstants.responseType.chebyshev) {
    result = _computeChebyshevFilterResponseValue(responseTypeSlider, Number(passbandAttenuation));
  } else if (responseType === FilterConstants.responseType.butterworthBessel) {
    result = _computedButterworthBesselFilterResponseValue(responseTypeSlider);
  }
  return Number(result);
}

function _computeChebyshevFilterResponseValue(inputSliderValue: number, passbandAttenuation: number): number {
  const staticValue = FilterConstants.slider.chebyshevLimit;
  let sliderValue = inputSliderValue;
  if (sliderValue < 0) sliderValue = 0;

  /*Our ripple will always be a percentage of the passband attenuation.   It needs to be positive, so we multiply by -1*/
  const aPassPositive = passbandAttenuation * -1;

  /*When sliderValue = 0, the ripple is always aPassPositive.   When sliderValue = AdiFW.filterConstants.slider.chebyshevLimit (if it could reach there), the ripple is always zero.
        The bender variable sets what happens in between.   If it is set at 1, the transition is completely linear.  If it is set at higher numbers
        then we bend the curve so it is an exponential.   In other words, the higher the number, the closer the values are to zero when the slider is in the middle.
        
        Our bender value is set to 14.6.  With the 0 to 46 sliderValue range we have, and with the -3dB aPassPositive default, this give us a good number range.  
        For example the number range includes the following values that customers will often want to see: 0.1, 0.2, 0.5, 1, 2, 3. If the number of sliderValues were ever adjusted, 
        then the bender value should be tweaked.*/

  const bender = 14.6;

  const percentValue = sliderValue / staticValue;
  const term1 = aPassPositive * Math.pow(bender, -percentValue);
  const term2 = 1 - percentValue;
  let result = term1 * term2;

  /*Prevent Chebyshev from showing 0*/
  if (result < 0.01) {
    result = 0.01;
  }

  /*Round to one digit for the bigger numbers so that chebyshev settings land on even rather than weird values*/
  if (result < 1) {
    result = Number(result.toFixed(2));
  } else {
    result = Number(result.toFixed(1));
  }

  return result;
}

function _computedButterworthBesselFilterResponseValue(sliderValue: number): number {
  const staticValue = FilterConstants.slider.besselButterworthLimit;
  let result = staticValue - sliderValue;
  result = result / (FilterConstants.slider.besselButterworthLimit - FilterConstants.slider.butterworthLimit);
  result = Number(result.toFixed(2));

  return result;
}
